// Pure decoder for the game event-log wire contract, mirroring roomProtocolAdapter.js. The socket
// transport owns connections; this owns the wire shape, so invalid frames are rejected before they
// reach the actionLog reducer and it stays unit-testable without STOMP.
//
// Envelope (EventLogService.liveEnvelope): { type:"GAME_EVENT", roomId, payload:<event> } where
// <event> = { id, seq, ts, type, actorSeat, visibility, payload }. Pass expectedRoomId to bind a
// room-topic subscription to its room; pass null for the shared /user/queue/game-events queue (the
// envelope's own roomId is trusted, and the caller checks it is a tracked room before dispatching).

const asObject = (value) =>
  value && typeof value === 'object' && !Array.isArray(value) ? value : null;

export const decodeGameEvent = (body, expectedRoomId) => {
  let parsed;
  try {
    parsed = typeof body === 'string' ? JSON.parse(body) : body;
  } catch (_) {
    return { error: 'invalid-json' };
  }
  const envelope = asObject(parsed);
  if (!envelope || envelope.type !== 'GAME_EVENT') return { error: 'invalid-envelope' };
  const event = asObject(envelope.payload);
  if (!event || typeof event.type !== 'string'
      || !Number.isSafeInteger(event.seq) || event.seq < 0) {
    return { error: 'invalid-event' };
  }
  const wireRoomId = envelope.roomId ?? event.roomId;
  if (expectedRoomId != null && String(wireRoomId) !== String(expectedRoomId)) {
    return { error: 'wrong-room' };
  }
  const roomId = wireRoomId != null ? Number(wireRoomId) : expectedRoomId;
  return { roomId, event };
};

export default decodeGameEvent;
